import { useEffect, useState } from "react";
import { useLocalization } from "../../context/LocalizationContext";
import { translateAsync, translateSync } from "../../services/translationService";

export function useLocalText(text) {
  const { locale } = useLocalization();
  const [value, setValue] = useState(() => translateSync(text, locale));

  useEffect(() => {
    let cancelled = false;
    translateAsync(text, locale).then((v) => { if (!cancelled) setValue(v); });
    return () => { cancelled = true; };
  }, [text, locale]);

  return value;
}
